// extracted by mini-css-extract-plugin
export default {"main":"TipoExamenSelector_main__ZIBEn"};